// Inventory Module - Root Sagas
// This file aggregates all inventory-related sagas

// Categories
import watchCategoriesListSaga from './Categories/List/store/saga'
import watchCategoriesFormSaga from './Categories/Form/store/saga'

// Types
import watchInventoryTypesListSaga from './Types/List/store/saga'
import watchInventoryTypesFormSaga from './Types/Form/store/saga'

// Products
import watchProductsListSaga from './Products/List/store/saga'
import watchProductsFormSaga from './Products/Form/store/saga'
import watchProductsDetailsSaga from './Products/Details/store/saga'

// Root saga for Inventory module
export default [
  watchCategoriesListSaga(),
  watchCategoriesFormSaga(),
  watchInventoryTypesListSaga(),
  watchInventoryTypesFormSaga(),
  watchProductsListSaga(),
  watchProductsFormSaga(),
  watchProductsDetailsSaga(),
]

